<template>
  <v-container class="d-flex flex-column ga-3">
    <UsageExample v-model="tab" :code="code" :tabs="tabs">
      <v-layout>
        <v-main height="450">
          <div class="d-flex flex-column align-center">
            <v-card elevation="4" class="ma-2 wrapper" height="auto">
              <v-card-title class="font-weight-bold text-capitalize">{{ size }}</v-card-title>
              <v-card-text>
                <CSOption
                  v-for="item in items"
                  :key="item.value"
                  v-model:is-expanded="expandedStates[item.id]"
                  class="cs-option"
                  :is-selected="isItemSelected(item)"
                  :multiple="isMulti"
                  :label="getLabelText(item)"
                  :caption="getCaptionText()"
                  :left-icon="leftIcon ? 'mdi-clipboard-check-outline' : ''"
                  :show-chip="chip"
                  :show-chevron="chevron"
                  :disabled="disabled"
                  :removable="isRemovable"
                  :size="size"
                  tooltip-text="Remove item from list?"
                  :item-id="item.id"
                  @keydown.space="!isTriggerAsWhole ? onSelect(item) : onExpand(item)"
                  @keydown.enter="!isTriggerAsWhole ? onSelect(item) : onExpand(item)"
                  @click="!isTriggerAsWhole ? onSelect(item) : onExpand(item)"
                  @dismiss="onDismiss($event)"
                  @mouseleave="$event.currentTarget.blur()"
                />
              </v-card-text>
            </v-card>
          </div>
        </v-main>
      </v-layout>
      <template #configuration>
        <div class="d-flex flex-column">
          <v-btn-toggle v-model="size" mandatory class="mb-4">
            <v-btn value="compact">Compact</v-btn>
            <v-btn value="regular">Regular</v-btn>
          </v-btn-toggle>
          <v-checkbox v-model="label" label="Label" />
          <v-checkbox v-model="caption" label="Caption" />
          <v-checkbox v-model="isMulti" label="Multi Select" />
          <v-checkbox v-model="leftIcon" label="Left Icon" />
          <v-checkbox v-model="chip" label="Chip" />
          <v-checkbox v-model="chevron" label="Chevron" />
          <v-checkbox v-model="isLongLabel" label="Long Label" />
          <v-checkbox v-model="isLongCaption" label="Long Caption" />
          <v-checkbox v-model="isRemovable" label="Removable" />
          <v-checkbox v-model="isTriggerAsWhole" label="Trigger As Whole" />
          <v-checkbox v-model="disabled" label="Disabled" />
          <v-btn class="mt-4" variant="outlined" @click="resetItems">Reset Items</v-btn>
        </div>
      </template>
    </UsageExample>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'CustomCSOption',
  components: { UsageExample },
  setup() {
    const code = `
<CSOption
    v-for="item in items"
    :key="item.value"
    v-model:is-expanded="expandedStates[item.id]"
    class="cs-option"
    :is-selected="isItemSelected(item)"
    :multiple="isMulti"
    :label="getLabelText(item)"
    :caption="getCaptionText()"
    :left-icon="leftIcon ? 'mdi-clipboard-check-outline' : ''"
    :show-chip="chip"
    :show-chevron="chevron"
    :disabled="disabled"
    :removable="isRemovable"
    :size="size"
    tooltip-text="Remove item from list?"
    :item-id="item.id"
    @keydown.space="!isTriggerAsWhole ? onSelect(item) : onExpand(item)"
    @keydown.enter="!isTriggerAsWhole ? onSelect(item) : onExpand(item)"
    @click="!isTriggerAsWhole ? onSelect(item) : onExpand(item)"
    @dismiss="onDismiss($event)"
    @mouseleave="$event.currentTarget.blur()"
  />
    `;
    return {
      code
    };
  },
  data() {
    return {
      tab: 'Select Usage',
      tabs: ['Select Usage'],
      items: [
        {
          id: 'label-1',
          title: 'Label 1',
          value: 'label 1'
        },
        {
          id: 'label-2',
          title: 'Label 2',
          value: 'label 2'
        }
      ],
      expandedStates: {},
      size: 'compact',
      label: true,
      caption: false,
      selectedValue: null,
      selectedValues: [],
      isMulti: false,
      leftIcon: false,
      chip: false,
      chevron: false,
      isLongLabel: false,
      isLongCaption: false,
      isRemovable: true,
      disabled: false,
      isTriggerAsWhole: false,
      longLabel: `Audit #103: Each of the variants can be customised to show different combinations of the content in the image above. `,
      longCaption: `Nulla dolor velit adipisicing duis excepteur esse in duis nostrud occaecat mollit incididunt deserunt sunt. Ut ut
    sunt laborum ex occaecat eu tempor labore enim adipisicing minim ad. Est in quis eu dolore occaecat excepteur fugiat
    dolore nisi aliqua fugiat enim ut cillum. Labore enim duis nostrud eu. Est ut eiusmod consequat irure quis deserunt
    ex. Enim laboris dolor magna pariatur. Dolor et ad sint voluptate sunt elit mollit officia ad enim sit consectetur
    enim.`
    };
  },
  watch: {
    isLongLabel(newValue) {
      if (newValue) {
        this.label = true;
      }
    },
    isLongCaption(newValue) {
      if (newValue) {
        this.caption = true;
      }
    },
    label(newValue) {
      if (!newValue) {
        this.isLongLabel = false;
      }
    },
    caption(newValue) {
      if (!newValue) {
        this.isLongCaption = false;
      }
    },
    isMulti(newValue) {
      if (newValue) {
        // Switching to multi-select: convert single selection to array
        if (this.selectedValue) {
          this.selectedValues = [this.selectedValue];
          this.selectedValue = null;
        }
      } else {
        // Switching to single-select: convert array to single value (take first selected)
        if (this.selectedValues.length > 0) {
          this.selectedValue = this.selectedValues[0];
          this.selectedValues = [];
        } else {
          this.selectedValue = null;
        }
      }
    }
  },
  methods: {
    getLabelText(item) {
      if (!this.label) return '';
      return this.isLongLabel ? this.longLabel : item.title;
    },
    getCaptionText() {
      if (!this.caption) return '';
      return this.isLongCaption ? this.longCaption : 'Caption';
    },
    isItemSelected(item) {
      if (this.isMulti) {
        return this.selectedValues.includes(item.value);
      }
      return this.selectedValue ? this.selectedValue === item.value : false;
    },
    onSelect(item) {
      if (this.disabled) return;
      if (this.isMulti) {
        const index = this.selectedValues.indexOf(item.value);
        if (index > -1) {
          // Remove from selection
          this.selectedValues.splice(index, 1);
        } else {
          // Add to selection
          this.selectedValues.push(item.value);
        }
      } else {
        // Single select mode
        this.selectedValue = this.selectedValue === item.value ? null : item.value;
      }
    },
    onExpand(item) {
      if (this.disabled) return;
      this.expandedStates[item.id] = !this.expandedStates[item.id];
    },
    onDismiss(itemId) {
      const item = this.items.find((item) => item.id === itemId);
      if (item) {
        // Remove from selectedValues if in multi-select mode
        if (this.isMulti) {
          const index = this.selectedValues.indexOf(item.value);
          if (index > -1) {
            this.selectedValues.splice(index, 1);
          }
        } else if (this.selectedValue === item.value) {
          // Clear single selection if this item was selected
          this.selectedValue = null;
        }
      }
      this.items = this.items.filter((item) => item.id !== itemId);
      delete this.expandedStates[itemId];
    },
    resetItems() {
      this.items = [
        { id: 'label-1', title: 'Label 1', value: 'label 1' },
        { id: 'label-2', title: 'Label 2', value: 'label 2' }
      ];
      this.expandedStates = {};
      this.selectedValue = null;
      this.selectedValues = [];
    }
  }
};
</script>

<style scoped>
.wrapper {
  width: 80%;
  background-color: rgb(238, 238, 238);

  .cs-option {
    margin-bottom: 8px;
  }
}
</style>
